(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solene-morse-landing"] && !Shopify.designMode) return;
  try {
    

function initSoleneMorse(){
const root=document.getElementById('solene-morse-landing');if(!root||root.dataset.initialized==='true')return;const strings=JSON.parse(document.getElementById('solene-morse-i18n').textContent);root.dataset.initialized='true';
const form=root.querySelector('form'),select=form.querySelector('[name=id]'),button=form.querySelector('[type=submit]'),status=root.querySelector('[data-status]'),price=root.querySelector('[data-price]'),message=form.querySelector('#sl-message'),preview=root.querySelector('[data-morse-preview]'),morseField=form.querySelector('[name="properties[Morse code]"]');
const quantity=form.querySelector('[name=quantity]'),reviewMessage=root.querySelector('[data-review-message]'),reviewColour=root.querySelector('[data-review-colour]'),reviewQuantity=root.querySelector('[data-review-quantity]'),reviewTotal=root.querySelector('[data-review-total]');
const route=window.Shopify?.routes?.root||'/',handle=root.dataset.handle;
const alphabet={A:'.-',B:'-...',C:'-.-.',D:'-..',E:'.',F:'..-.',G:'--.',H:'....',I:'..',J:'.---',K:'-.-',L:'.-..',M:'--',N:'-.',O:'---',P:'.--.',Q:'--.-',R:'.-.',S:'...',T:'-',U:'..-',V:'...-',W:'.--',X:'-..-',Y:'-.--',Z:'--..','0':'-----','1':'.----','2':'..---','3':'...--','4':'....-','5':'.....','6':'-....','7':'--...','8':'---..','9':'----.'};
const encode=value=>value.trim().toUpperCase().split(/ +/).map(word=>[...word].map(char=>alphabet[char]||'').join(' ')).join(' / ');
let product=null,busy=false,currency='USD';
const variant=()=>product?.variants.find(v=>String(v.id)===select.value);
const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency,currencyDisplay:'code'}).format(cents/100);
function updateReview(){const v=variant(),qty=Number(quantity.value),validQty=Number.isInteger(qty)&&qty>=1&&qty<=10;quantity.setCustomValidity(validQty?'':strings.quantity_error);reviewMessage.textContent=message?(message.value.trim().toUpperCase()||strings.message_prompt):'I LOVE YOU';reviewColour.textContent=v?(v.public_title||v.title==='Default Title'&&strings.fixed_design||v.title):strings.checking_selection;reviewQuantity.textContent=validQty?String(qty):strings.check_quantity;reviewTotal.textContent=v&&validQty?money(v.price*qty):strings.checking;}
function updateMessage(){if(!message)return;message.setCustomValidity(!message.value.trim()?strings.message_required:message.value.length>message.maxLength?strings.too_long:!/^[a-zA-Z0-9 ]+$/.test(message.value)?strings.supported_characters:'');const code=encode(message.value);if(preview)preview.textContent=code||strings.code_preview;morseField.value=code;root.querySelector('[data-count]').textContent=message.value.length;updateReview();}
function updateVariant(){const v=variant();button.disabled=busy||!v?.available;button.textContent=busy?strings.adding:v?.available?root.dataset.cta:strings.unavailable;if(v){price.textContent=money(v.price)+strings.per_piece;status.textContent=v.available?strings.available:strings.option_unavailable;}updateReview();}
if(message){message.addEventListener('input',updateMessage);updateMessage();root.querySelectorAll('[data-message]').forEach(chip=>chip.addEventListener('click',()=>{message.value=chip.dataset.message;updateMessage();message.focus();}));}
const mode=form.querySelector('#sl-message-mode'),preset=form.querySelector('#sl-preset'),presetWrap=form.querySelector('[data-preset-wrap]');
function applyMode(){if(!mode||!message)return;const isPreset=mode.value==='Preset';presetWrap.hidden=!isPreset;message.readOnly=isPreset;if(isPreset)message.value=preset.value;updateMessage();}
if(mode){mode.addEventListener('change',applyMode);preset.addEventListener('change',applyMode);root.querySelectorAll('[data-message]').forEach(chip=>chip.addEventListener('click',()=>{mode.value='Custom';message.readOnly=false;presetWrap.hidden=true;}));}
select.addEventListener('change',()=>{updateVariant();const v=variant();if(!v)return;const url=new URL(window.location.href);url.searchParams.set('variant',String(v.id));url.searchParams.delete('option_values');window.history.replaceState(window.history.state,'',url);});
quantity.addEventListener('input',updateReview);
Promise.all([fetch(route+'products/'+encodeURIComponent(handle)+'.js').then(r=>{if(!r.ok)throw Error('Product unavailable');return r.json();}),fetch(route+'cart.js').then(r=>{if(!r.ok)throw Error('Currency unavailable');return r.json();})]).then(([p,cart])=>{product=p;currency=cart.currency;if(!currency)throw Error('Currency unavailable');const requested=new URL(window.location.href).searchParams.get('variant');const existing=[requested,root.dataset.selectedVariant,select.value].find(id=>p.variants.some(v=>String(v.id)===id));select.replaceChildren(...p.variants.map(v=>{const o=document.createElement('option');o.value=v.id;o.textContent=(v.public_title||v.title==='Default Title'&&strings.fixed_design||v.title)+(v.available?'':strings.unavailable_suffix);return o;}));if(p.variants.some(v=>String(v.id)===existing))select.value=existing;updateVariant();}).catch(()=>{button.disabled=true;button.textContent=strings.load_failed_button;status.textContent=strings.load_failed;});
form.addEventListener('submit',async event=>{event.preventDefault();if(busy)return;if(message){message.value=message.value.trim().toUpperCase();updateMessage();}updateReview();if(!form.reportValidity())return;if(!variant()?.available){status.textContent=strings.choose_available;return;}busy=true;updateVariant();try{const data=new FormData(form);const drawer=document.querySelector('cart-drawer');if(drawer&&typeof drawer.renderContents==='function'){data.set('sections','cart-drawer,cart-icon-bubble');data.set('sections_url',window.location.pathname);drawer.setActiveElement?.(button);}const response=await fetch(route+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});const result=await response.json();if(!response.ok)throw Error(result.description||result.message||strings.cart_error);status.textContent=strings.added;if(window.SoleneStore?.showCart(result,button)){busy=false;updateVariant();status.textContent=strings.added;}else{window.location.assign(route+'cart');}}catch(error){busy=false;updateVariant();status.textContent=error.message||strings.cart_error;}});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initSoleneMorse,{once:true});}else{initSoleneMorse();}
document.addEventListener('shopify:section:load',initSoleneMorse);


  } catch(e) { console.error(e); }
})();
})();
